/**
 * @fileoverview FindTour.jsx
 * 
 * © 2026 KITH Travels (Pvt) Ltd. All rights reserved.
 * This software is the confidential and proprietary information of KITH Travels.
 * You shall not disclose such Confidential Information and shall use it only in 
 * accordance with the terms of the license agreement you entered into with KITH Travels.
 */
import React from 'react'
import Header from '../components/layout/Header'
import TourSearch from '../components/tours/TourSearch'

function FindTour() {
  return (
    <div>
        <TourSearch />
    </div>
  )
}

export default FindTour